import { Cookies } from 'react-cookie'
// constants
import { REDIRECT_URL_FIELD } from 'constants/cookies'

const browserCookies = new Cookies()

export const getRedirectUrl = (cookies = browserCookies) => cookies.get(REDIRECT_URL_FIELD)

export const clearRedirectUrl = (cookies = browserCookies) => cookies.remove(REDIRECT_URL_FIELD, { path: '/' })
